import {PropTypes as MobXPropTypes} from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import autobind from 'common/decorators/autobind.js';
import CollapsibleNumber from 'core/components/CollapsibleNumber.js';
import Icon from 'core/components/Icon.js';
import Link from 'core/components/Link.js';
import WebsiteLink from 'core/components/WebsiteLink.js';

export default class Info extends React.Component {
    static propTypes = {
        address: PropTypes.string,
        children: PropTypes.oneOfType(PropTypes.string, PropTypes.elementType),
        client: PropTypes.string,
        fax: PropTypes.shape({
            description: PropTypes.string,
            number: PropTypes.string.isRequired,
        }),
        languages: MobXPropTypes.arrayOrObservableArrayOf(PropTypes.string),
        onClickFaxNumber: PropTypes.func,
        onShowPhoneNumber: PropTypes.func,
        phones: PropTypes.shape({
            numbers: MobXPropTypes.arrayOrObservableArrayOf(
                PropTypes.shape({
                    description: PropTypes.string,
                    number: PropTypes.string.isRequired,
                }),
            ),
        }),
        website: PropTypes.shape({
            href: PropTypes.string.isRequired,
            analyticsEventData: PropTypes.shape({
                eventName: PropTypes.string,
                eventUrl: PropTypes.string,
                data: PropTypes.shape({
                    [PropTypes.string]: PropTypes.oneOfType([
                        PropTypes.string,
                        PropTypes.number,
                    ]),
                }).isRequired,
            }),
        }),
    };

    static defaultProps = {
        languages: [],
        phones: {},
    };

    renderFax() {
        const {description, number} = this.props.fax;
        const {onClickFaxNumber} = this.props;
        return (
            <div>
                <dt>
                    <Icon name="print" />
                    {'Fax:'}
                </dt>
                <dd aria-live="polite">
                    <CollapsibleNumber
                        number={number}
                        onClick={() =>
                            onClickFaxNumber && onClickFaxNumber(number)
                        }
                        type="fax"
                    />
                    {description && <p> — {description}</p>}
                </dd>
            </div>
        );
    }

    renderLanguages() {
        const {languages} = this.props;

        return (
            <div>
                <dt>
                    <Icon name="language" />
                </dt>
                <dd>
                    {'Languages spoken: English, '}
                    {languages.join(', ')}
                </dd>
            </div>
        );
    }

    renderPhones() {
        const {phones, onShowPhoneNumber} = this.props;
        return phones.numbers?.map((phone) => {
            if (!phone) {
                return null;
            }
            const {description, number} = phone;
            return (
                <div key={number}>
                    <dt>
                        <Icon name="phone" />
                        {'Phone:'}
                    </dt>
                    <dd aria-live="polite">
                        <CollapsibleNumber
                            number={number}
                            onClick={() => onShowPhoneNumber(number)}
                            type="phone"
                        />
                        {description && <p> — {description}</p>}
                    </dd>
                </div>
            );
        });
    }

    renderWebsite() {
        return (
            <div>
                <dt>
                    <Icon name="externalLink" />
                    {'Website: '}
                </dt>
                <dd>
                    <WebsiteLink {...this.props.website} />
                </dd>
            </div>
        );
    }

    @autobind
    renderPracticeName() {
        const {practiceName, practiceUrl} = this.props;
        return practiceUrl ? (
            <h3>
                <Link href={practiceUrl}>{practiceName}</Link>
            </h3>
        ) : (
            <h3>{practiceName}</h3>
        );
    }

    renderAddress() {
        return (
            <div>
                <dt>
                    <Icon name="mapPin" />
                    {'Address: '}
                </dt>
                <dd>
                    <Link
                        href={`https://www.google.com/maps/preview/?q=${this.props.address}`}
                        isExternalLink={true}
                    >
                        {this.props.address}
                    </Link>
                </dd>
            </div>
        );
    }

    render() {
        const {
            address,
            client,
            fax,
            languages,
            phones,
            practiceName,
            website,
        } = this.props;
        return (
            <dl className="icon-list">
                {practiceName && this.renderPracticeName()}
                {address && this.renderAddress()}
                {phones && this.renderPhones()}
                {fax && this.renderFax()}
                {!client && website && this.renderWebsite()}
                {languages.length > 0 && this.renderLanguages()}
                {this.props.children}
            </dl>
        );
    }
}
